/* `/zadania`'s card heading — KANON "Karty zadań" `catalogue6.css` `.k7-reason` / `.k7-big`.
 *
 * Text that must be read is `--text-2` where the canon writes `--text-3`: `--text-3` measures 3.0:1
 * (Flame) and 4.0:1 (Flame Dark) on these surfaces — the standing deviation `DetailTab.module.css`
 * records, kept by the 31.08 decision on a measured contrast number. */

.heading {
  display: flex;
  gap: var(--space-14px);
  align-items: center;
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

/* A notch under the canon's 19/14 (owner, 25 September 2026: the heading read huge). */
.title {
  font-size: var(--fs-task-title);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-heading);
  color: var(--text);
}

.line {
  overflow: hidden;
  font-size: var(--fs-label-md);
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-2);
}

.figure {
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: flex-end;
}

.value {
  font-size: var(--fs-task-figure);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-none);
  letter-spacing: var(--ls-home-figure);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

.danger {
  color: var(--danger);
}

.small {
  font-size: var(--fs-task-figure-unit);
  font-weight: var(--fw-bold);
  letter-spacing: normal;
  color: var(--text-2);
}

.caption {
  margin-block-start: var(--space-1);
  font-size: var(--fs-label);
  color: var(--text-2);
}
